import type { TFunction } from "i18next"

import { Activity, AlertCircle, Database, Search, Users } from "@/components/icons"

export const getEmptyStates = (t: TFunction) => {
  return {
    dataSources: {
      icon: Database,
      title: t("adminDashboard.emptyStates.dataSources.title"),
      description: t("adminDashboard.emptyStates.dataSources.description"),
    },
    agentRuns: {
      icon: Activity,
      title: t("adminDashboard.emptyStates.agentRuns.title"),
      description: t("adminDashboard.emptyStates.agentRuns.description"),
    },
    tokenUsage: {
      icon: Activity,
      title: t("adminDashboard.emptyStates.tokenUsage.title"),
      description: t("adminDashboard.emptyStates.tokenUsage.description"),
    },
    tokenMetrics: {
      icon: Activity,
      title: t("adminDashboard.emptyStates.tokenMetrics.title"),
      description: t("adminDashboard.emptyStates.tokenMetrics.description"),
    },
    topUsers: {
      icon: Users,
      title: t("adminDashboard.emptyStates.topUsers.title"),
      description: t("adminDashboard.emptyStates.topUsers.description"),
    },
    moduleUsage: {
      icon: Activity,
      title: t("adminDashboard.emptyStates.moduleUsage.title"),
      description: t("adminDashboard.emptyStates.moduleUsage.description"),
    },
    searches: {
      icon: Search,
      title: t("adminDashboard.emptyStates.searches.title"),
      description: t("adminDashboard.emptyStates.searches.description"),
    },
    events: {
      icon: AlertCircle,
      title: t("adminDashboard.emptyStates.events.title"),
      description: t("adminDashboard.emptyStates.events.description"),
    },
  }
}
